<div class="container-fluid">
    <div class="row header-container">
        <div class="col-12 p-0">
            <banner></banner>
        </div>
        <div class="col-sm-12">
            <header>
                <div class="row header-background">
                    <div class="col-sm-12 col-md-4">
                        <h1 class="mb-0"><a href="/"><img class="logo" src="../../../assets/paetep_logo.png" title="PAETEP by Edulink"/></a></h1>
                    </div>
                    <nav class="col-md-8 d-none d-md-flex justify-content-end align-items-center">
                        <ul class="float-end mb-0">
                            <li>
                                <a class="nav-link" href="https://edulinksolutions.freshdesk.com/support/solutions" target="_blank">Support</a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </header>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <div class="container">
                <ui-view name="content"></ui-view>
            </div>
        </div>
    </div>
</div>
